module.exports = __webpack_public_path__ + "img/p.d7ec489b.jpg";